import { render, staticRenderFns } from "./ReportAside.vue?vue&type=template&id=0378962d&scoped=true"
import script from "./ReportAside.vue?vue&type=script&lang=js"
export * from "./ReportAside.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0378962d",
  null
  
)

export default component.exports